import { withRouter } from 'react-router-dom';
import WithSystem from './../service/WithSystem';
const gradeFilter = JSON.parse(window.gradeFilter);
class GradeDropDown extends React.Component {
  constructor(props) {
    super(props);
    this.box = React.createRef();
    this.state ={dropdownToggle:false}
  }
  setGradeItems = (selectedId, event) => {
    let grades = this.props.queryFilter.grades;
    grades = grades ? grades.split(',') : [];
    if (event.target.checked) {
      grades = grades.length ? [...grades, selectedId] : [selectedId];
    } else {
      grades = grades.filter((grade) => {
        return (grade != selectedId);
      });
    }
    grades = grades.length ? grades.join() : false;
    this.props.setGlobalState({ grades });
  }
  SetDropdownToggleVall = ()=>{
    this.setState({dropdownToggle:!this.state.dropdownToggle},()=>{
      document.addEventListener('click', this.handleOutsideClick);
    });
  }
  handleOutsideClick = (event) => {
    if (this.box && !this.box.current.contains(event.target)) {
      this.setState({dropdownToggle:!this.state.dropdownToggle},()=>{
        if (this.state.dropdownToggle == true) {
          this.setState({ dropdownToggle: false });
        }
        document.removeEventListener('click', this.handleOutsideClick);
      });
    }
  }
  render() {
    const gradeItems = this.props.queryFilter['grades'] ? this.props.queryFilter['grades'].split(',') : [];
    return (
          <div ref={this.box} onClick={() => this.SetDropdownToggleVall()} className={this.state.dropdownToggle  == true ? 'branch-list active' : 'branch-list'}>
            <span className="filter-subtxt">Grade</span>
            <div className="report-list-menu" >
              <div className="branch-list-sec">Select Grade</div>
              <div className="list_menu_section" >
                <ul className="list_menu">
                {gradeFilter.map((course) => {
                let hasChecked = gradeItems.includes(course.gr_name);
                return (
                  <li key={`grade_${course.gr_name}`}><label>
                   <span>
                      <input id={`grade_${course.gr_name}`} onClick={(e) => this.setGradeItems(`${course.gr_name}`, e)} className="bc_column_visible bc_initial_events uncheckbox" defaultChecked={hasChecked} data-column-name="Attendee Name" type="checkbox" data-field-name="attendee_name" />
                    <span className="checkedmark"></span> 
                  </span>
                    <span className="dropdownlist_singleline">{course.gr_name}</span></label></li>)
                })}
                </ul>
             </div>
           </div>
         </div>
    );
  }
}
export default withRouter(WithSystem(GradeDropDown));